import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	title: {
		fontWeight: 600,
		fontSize: 18,
		color: '#394A61',
		padding: '8px 0px',
	},
}));

export default useStyles;
